/* unplugin-vue-components disabled */import script from "./AdminPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPrint.vue?vue&type=script&setup=true&lang=js"

import "./AdminPrint.vue?vue&type=style&index=0&id=07b12750&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b12750"]])

export default __exports__